<template>
  <div class="auth-box-w">
    <Logo/>

    <h4
        :style="{
        paddingBottom: '10px',
        borderBottom: `2px solid ${tenantColor}`,
        color: '#475569',
        fontWeight: 600,
        textAlign: 'center',
        marginBottom: '20px'
      }">
      Neues Passwort erstellen
    </h4>

    <form @submit.prevent="createNewPassword" novalidate>
      <!-- New Password -->
      <div class="form-group">
        <BaseInput
            v-model="formData.newPassword"
            type="password"
            label="Neues Passwort"
            :required="true"
            :inputStyle="{ border: '1px solid rgba(0, 0, 0, 0.3)' }"
            :validation="v$.newPassword"
            :messages="v$.newPassword.required.$invalid ? v$.newPassword.required.$message : v$.newPassword.minLength.$message"
        />
        <div class="pre-icon os-icon os-icon-lock"
             :style="{ color: tenantColor }">
        </div>
      </div>

      <!-- Repeat New Password -->
      <div class="form-group">
        <BaseInput
            v-model="formData.repeatNewPassword"
            type="password"
            label="Passwort wiederholen"
            :required="true"
            :inputStyle="{ border: '1px solid rgba(0, 0, 0, 0.3)' }"
            :validation="v$.repeatNewPassword"
            :messages="v$.repeatNewPassword.required.$invalid ? v$.repeatNewPassword.required.$message : v$.repeatNewPassword.sameAsNewPassword.$message"
        />
        <div class="pre-icon os-icon os-icon-lock"
             :style="{ color: tenantColor }">
        </div>
      </div>

      <div class="buttons-w d-flex justify-content-center">
        <button
            class="btn"
            type="submit"
            :disabled="isSubmitting"
            :style="{ backgroundColor: tenantColor, color: 'white' }">
          Passwort ändern
        </button>
      </div>

    </form>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import useVuelidate from '@vuelidate/core';
import {helpers, minLength, required, sameAs} from '@vuelidate/validators';
import BaseInput from '@/components/base/BaseInput.vue';
import {useRoute} from 'vue-router'
import authService from '@/api/Auth';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import router from '@/router';
import Logo from "@/components/Logo.vue";
import {useTenantColor} from "@/shared/utils/ThemeUtils";

const tenantKey = process.env.VUE_APP_TENANT_KEY
const {tenantColor} = useTenantColor(tenantKey)

const {t} = useI18n();
const isSubmitting = ref(false);
const route = useRoute()

const actionToken = route.query.action_token

const formData = ref({
  newPassword: '',
  repeatNewPassword: ''
});

// Vuelidate rules
const rules = computed(() => ({
  newPassword: {
    required: helpers.withMessage('Dieses Feld ist erforderlich', required),
    minLength: helpers.withMessage(
        'Das Passwort muss mindestens 6 Zeichen haben',
        minLength(6)
    )
  },
  repeatNewPassword: {
    required: helpers.withMessage('Dieses Feld ist erforderlich', required),
    sameAsNewPassword: helpers.withMessage(
        'Passwörter stimmen nicht überein',
        sameAs(formData.value.newPassword)
    )
  }
}));

const v$ = useVuelidate(rules, formData);


async function createNewPassword() {
  try {
    v$.value.$touch();
    if (v$.value.$invalid) return;

    if (isSubmitting.value) return;
    isSubmitting.value = true;

    await authService.newPassword({
      actionToken: actionToken,
      newPassword: formData.value.newPassword,
      repeatedNewPassword: formData.value.repeatNewPassword,
    });

    isSubmitting.value = false;
    await router.push({name: 'login'});

    SuccessToast(
        t('Ihr Passwort wurde erfolgreich erstellt. Sie können sich jetzt mit Ihren Zugangsdaten anmelden.')
    );
  } catch (err) {
    isSubmitting.value = false;
    await ErrorToast(err);
  }
}

onMounted(() => {
  CloseToast();
});
</script>
